var _rect, _path, _g, _rect2, _rect3, _rect4, _rect5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 111,
    viewBox: "0 0 156 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 156,
    height: 110,
    transform: "translate(0 0.562378)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7171_35376)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7171_35376)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7171_35376",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 22,
    width: 126,
    height: 66
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M162.091 22.3828H39.9091C38.8547 22.3828 38 23.2435 38 24.3051V85.8197C38 86.8814 38.8547 87.742 39.9091 87.742H162.091C163.145 87.742 164 86.8814 164 85.8197V24.3051C164 23.2435 163.145 22.3828 162.091 22.3828Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7171_35376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.091 22.3828H39.9091C38.8547 22.3828 38 23.2435 38 24.3051V85.8197C38 86.8814 38.8547 87.742 39.9091 87.742H162.091C163.145 87.742 164 86.8814 164 85.8197V24.3051C164 23.2435 163.145 22.3828 162.091 22.3828Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M142.24 64.2245C147.373 64.2894 165.964 76.7816 172.068 78.2131C178.173 79.6445 176.23 87.9073 176.23 87.9073H77.8662C77.8662 87.9073 112.411 68.844 116.435 69.82C120.458 70.796 119.903 73.008 123.371 73.0731C126.84 73.1382 137.107 64.1595 142.24 64.2245Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8193 55.2502C53.5226 55.3399 41.5833 72.5656 37.6629 74.5395C33.7425 76.5134 34.9899 87.9073 34.9899 87.9073H98.1613C98.1613 87.9073 75.9756 61.6203 73.3917 62.9661C70.8078 64.3118 71.1644 67.3621 68.9368 67.4518C66.7092 67.5416 60.1159 55.1607 56.8193 55.2502Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.641 70.5996C140.344 70.6471 128.405 79.7766 124.485 80.8226C120.564 81.8688 121.811 87.9073 121.811 87.9073H184.983C184.983 87.9073 162.797 73.9756 160.213 74.6889C157.63 75.4021 157.986 77.0187 155.759 77.0663C153.531 77.1139 146.937 70.5521 143.641 70.5996Z",
    fill: "#D9D9D9"
  }))))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 12,
    y: 45.0746,
    width: 34.202,
    height: 7.2085,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 12,
    y: 55.829,
    width: 38.0641,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 12,
    y: 60.0472,
    width: 42.9645,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 12,
    y: 64.2655,
    width: 26.8707,
    height: 2.67236,
    rx: 1,
    fill: "#BDBDBD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7171_35376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(80 23.0624)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7171_35376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 126,
    height: 66,
    fill: "white",
    transform: "translate(38 22.0624)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageRight);
export default __webpack_public_path__ + "static/media/image-right.70e831e68a7cce31e785568648c48203.svg";
export { ForwardRef as ReactComponent };